import { useStatistic } from "@gymflow/api";
import { DATE_FORMAT, PARAMETER_DATE_ONLY_FORMAT } from "@gymflow/common";
import moment from "moment-timezone";
import QueryString from "qs";
import { useContext } from "react";
import { useHistory } from "react-router";

import { usePortalRoutes } from "../../../../hooks/usePortalRoutes";
import { ApiResolverContext } from "../../../../providers/ApiResolverProvider/ApiResolverContext";
import { RouteFeature } from "../../../../routes/feature";
import { RouteLayout } from "../../../../routes/layout";
import useGymflowModels from "../../../../store";
import ReportWidgetCard from "../../../ReportWidgetCard/ReportWidgetCard";
import { ReportContext } from "../../ReportContext";

export const ReportMembersPausedWidget = ({
  parentRoute,
}: {
  parentRoute: string;
}) => {
  const { createClubLink } = usePortalRoutes();

  const context = useContext(ReportContext);

  const { api } = useGymflowModels();
  const { clubId } = useContext(ApiResolverContext);
  const { data, isLoading } = useStatistic({
    api,
    clubId,
    trendPeriod: "MONTH",
    categories: ["membership"],
    membershipFields: ["total", "active", "overdue", "paused", "pending"],
    start:
      context.endDate &&
      moment(context.endDate, DATE_FORMAT).format(PARAMETER_DATE_ONLY_FORMAT),
    end:
      context.endDate &&
      moment(context.endDate, DATE_FORMAT).format(PARAMETER_DATE_ONLY_FORMAT),
    membershipIncluded: context?.membershipIncluded?.map(({ id }) => id),
    membershipExcluded: context?.membershipExcluded?.map(({ id }) => id),
  });
  const history = useHistory();

  return (
    <ReportWidgetCard
      title="Paused Memberships "
      value={data?.membership?.paused?.total?.toString() || "0"}
      isLoading={isLoading}
      explanation="Sum of all recurring and pre-paid membership in a Paused status. Does not include memberships that are scheduled to be paused."
      variation={data?.membership?.paused?.var}
      positiveIsBad
      onClick={() =>
        history.push({
          pathname: createClubLink(
            RouteLayout.Staff,
            RouteFeature.PausedMemberships,
          ),
          search: QueryString.stringify({
            startDate: context.startDate,
            endDate: context.endDate,
            backRoute: parentRoute,
          }),
        })
      }
    />
  );
};
